// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"222":"4e1e7394bc2904f4","378":"9edc04ccb0adffed","405":"c371b07e2dae2a1b","888":"b8422dd6a1c55f6e","937":"9edc04ccb0adffed","961":"f8753fabd7183d72"}[chunkId] + ".css";
};